import { create } from 'zustand';

const useAuthStore = create((set, get) => ({
  user: JSON.parse(localStorage.getItem('michca_user') || 'null'),
  token: localStorage.getItem('michca_token') || null,

  setAuth: (user, token) => {
    localStorage.setItem('michca_token', token);
    localStorage.setItem('michca_user', JSON.stringify(user));
    set({ user, token });
  },

  logout: () => {
    localStorage.removeItem('michca_token');
    localStorage.removeItem('michca_user');
    set({ user: null, token: null });
  },

  isAdmin: () => get().user?.role === 'admin',
  isTeamUser: () => get().user?.role === 'team_user',
  isScheduler: () => ['admin', 'scheduler'].includes(get().user?.role),
  canEdit: () => ['admin', 'scheduler'].includes(get().user?.role),
}));

export default useAuthStore;
